import React, { Component } from 'react';
import PropTypes from 'prop-types';
import noticeSubscriber from '../service/noticesubscriber';

function withNoticeSubscribe(WrappedComponent) {
    return class WithNoticeSubscribe extends Component {
        static propTypes = {
            symbol: PropTypes.string,
        }

        componentDidMount() {
            const { symbol } = this.props;

            const ticker = symbol ? symbol.substring(0, symbol.indexOf('.')) : null;

            this.channel = noticeSubscriber.subscribe(ticker);
        }

        componentWillUnmount() {
            if (this.channel) {
                noticeSubscriber.unsubscribe(this.channel);
            }
        }

        render() {
            return <WrappedComponent {...this.props} />;
        }
    };
}

export default withNoticeSubscribe;



/** WEBPACK FOOTER **
 ** /src/shared/hoc/withNoticeSubscribe.js
 **/